import React from 'react';

export const COMPARISON_COMFORTABLE_PLAN_COUNT = 4;
const LABEL_COLUMN_WIDTH = '11rem';
const PLAN_COLUMN_WIDTH = '11rem';

export const comparisonNeedsHorizontalScroll = (planCount) => planCount > COMPARISON_COMFORTABLE_PLAN_COUNT;

export const comparisonTableStyle = (planCount) => {
  if (!comparisonNeedsHorizontalScroll(planCount)) {
    return { width: '70%' };
  }

  return {
    width: '100%',
    minWidth: `calc(${LABEL_COLUMN_WIDTH} + ${planCount} * ${PLAN_COLUMN_WIDTH})`,
  };
};

export const ComparisonTableColumns = ({ planCount, packages }) => {
  if (!comparisonNeedsHorizontalScroll(planCount)) return null;

  return (
    <colgroup>
      <col style={{ width: LABEL_COLUMN_WIDTH }} />
      {packages.map((pack) => (
        <col key={pack.id} />
      ))}
    </colgroup>
  );
};
